import { View, Text, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Fonts from "../../../styles/typography";
import * as Colors from "../../../styles/colors";

export default function UnityInfo({ unityData }) {
  return (
    <View>
      <View style={styles.viewUnityInfoData}>
        <View style={styles.doubleText}>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="car" size={32} />
              <Text style={styles.label}>Placa</Text>
            </View>
            <Text style={styles.info}>{unityData.placa}</Text>
          </View>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="ticket-confirmation" size={32} />
              <Text style={styles.label}>Ticket</Text>
            </View>
            <Text style={styles.info}>{unityData.numeroTicket}</Text>
          </View>
        </View>
        <View style={styles.doubleText}>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="timer" size={32} />
              <Text style={[styles.label, {fontSize: Fonts.FONT_SIZE_16}]}>Permanência</Text>
            </View>
            <Text style={styles.info}>{unityData.permanencia}</Text>
          </View>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="calendar" size={32} />
              <Text style={styles.label}>Entrada</Text>
            </View>
            <Text style={styles.info}>{unityData.entrada}</Text>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewUnityInfoData: {
    // paddingHorizontal: 8,
  },
  viewUnityInfoTitle: {
    flexDirection: "row",
    alignItems: "center",
  },
  doubleText: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    // padding: 8,
    marginHorizontal: 4,
    marginVertical: 8,
  },
  label: {
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.BLACK,
    fontWeight: "bold",
    marginHorizontal: 4,
  },
  info: {
    fontSize: Fonts.FONT_SIZE_16,
  },
  infoTicket: {
    borderWidth: 1,
    borderRadius: 8,
    padding: 4,
    marginHorizontal: 4,
    width: "40%",
    alignContent: "center",
  },
  horizontalInfo: {
    flexDirection: "row",
    alignItems: "center",
  },
});
